import { Box, Container, Text } from '@chakra-ui/react';
import { Locales, TonConnectButton, useTonConnectUI, useTonWallet } from '@tonconnect/ui-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export default function TonkeeperAuthPage() {
    const wallet = useTonWallet();
    const [tonConnectUI, setOptions] = useTonConnectUI();
    const [t, i18next] = useTranslation()

    useEffect(() => {
        setOptions({language: i18next.language as Locales})
    }, [])

    return (
        <Container display="flex" alignItems="center" height="100vh" justifyContent="center">
            <Box
                paddingBottom="230px"
                display="flex"
                flexDirection="column"
                alignItems="center"
                gap="5"
                color="#fff"
                fontWeight="300">
                <Box display="flex" flexDirection="column" gap="9px" alignItems="center">
                    <LazyLoadImage
                        effect="blur"
                        src={process.env.PUBLIC_URL + '/images/replenishment/tonkeeper.png'}
                        style={{ height: '100px', borderRadius: '10px' }}
                    />
                    <Text fontSize="16px">Tonkeeper</Text>
                </Box>
                <Box>{!wallet && <TonConnectButton />}</Box>
            </Box>
        </Container>
    );
}
